// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"0307771b","55":"de31042a","132":"727341f2","464":"763a7836","554":"e4a7dff3","562":"d375fec4","582":"e7e9cce3","911":"bf87c841","976":"00f28190"}[chunkId] + ".chunk.js";
};